import { useRouter } from 'next/router';
import { ErrorBoundary } from 'react-error-boundary';
import Track from '@/lib/trackjs';

function Fallback({ resetErrorBoundary }) {
  return (
    <div role="alert" style={{ padding: 24 }}>
      <p>
        This part of the app could not be displayed. Try again or open another
        page.
      </p>
      <button type="button" onClick={resetErrorBoundary}>
        Try again
      </button>
    </div>
  );
}

// Keep session providers mounted when a page or data provider fails. Navigation
// resets the failed subtree, and retry does not discard the authenticated client.
export default function AppErrorBoundary({ children }) {
  const router = useRouter();
  return (
    <ErrorBoundary
      FallbackComponent={Fallback}
      onError={(error) => Track.track(error)}
      resetKeys={[router.asPath]}
    >
      {children}
    </ErrorBoundary>
  );
}
